<template>
  <div class="vue-accordion">
    <slot />
  </div>
</template>

<script>
  export default {
    name:       'VueAccordion',
    props:      {
      multiple:    {
        type:     Boolean,
        required: false,
        default:  false,
      },
    },
    data(){
      return {
        items:     [],
        openItems: [],
      };
    },
    methods:    {
      openItem(idx) {
        if (this.multiple && this.openItems.indexOf(idx) > -1) {
          this.openItems = this.openItems.filter((item) => item !== idx);
        } else if (this.multiple) {
          this.openItems.push(idx);
        } else if (this.openItems.indexOf(idx) > -1) {
          this.openItems = [];
        } else {
          this.openItems = [idx];
        }

        this.handleItems();
      },
      handleItems() {
        this.items.forEach((item) => {
          item.$data.open = this.openItems.indexOf(item.$data.idx) > -1;
        });
      },
      register(item) {
        item.$data.idx = this.items.length;

        this.items.push(item);

        if (item.initOpen) {
          this.openItems.push(item.$data.idx);
        }

        this.handleItems();
      },
    },
    beforeDestroy() {
      this.items = [];
      this.openItems = [];
    },
  };
</script>

<style scoped lang="scss">

@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.vue-accordion {
  display: block;
  margin: $large+rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VueAccordion.vue